export const selectWorkshopAdmin = (state) => state.workshopsAdmin;

export const selectWorkshopAdminList = (state) => state.workshopsAdmin.list;
export const selectWorkshopAdminListLoading = (state) => state.workshopsAdmin.loading;
export const selectWorkshopAdminListLoadingCount = (state) => state.workshopsAdmin.loadingCount;
export const selectWorkshopAdminListError = (state) => state.workshopsAdmin.error;

export const selectWorkshopAdminBrands = (state) => state.workshopsAdmin.brands;
export const selectWorkshopAdminNetworks = (state) => state.workshopsAdmin.networks;
export const selectWorkshopAdminServices = (state) => state.workshopsAdmin.services;
export const selectWorkshopAdminCategories = (state) => state.workshopsAdmin.categories;

export const selectWorkshopAdminBrandsLoading = (state) => state.workshopsAdmin.loadingBrands;
export const selectWorkshopAdminNetworksLoading = (state) => state.workshopsAdmin.loadingNetworks;
export const selectWorkshopAdminServicesLoading = (state) => state.workshopsAdmin.loadingServices;
export const selectWorkshopAdminCategoriesLoading = (state) => state.workshopsAdmin.loadingCategories;